package com.hyperether.goodjob.scenes.addNew

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.hyperether.goodjob.map.Marker
import com.hyperether.goodjob.models.AddressObject
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.repository.Repository
import com.hyperether.goodjob.repository.remote.model.ParsedAddress
import com.hyperether.goodjob.repository.remote.model.Resource
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.contact_name_required
import com.hyperether.goodjob.resources.unknown_error
import com.hyperether.resources.LocalizedStrings
import com.hyperether.resources.currentLanguage
import com.hyperether.resources.stringResourcePlain
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class AddContactViewModel(val repository: Repository) : ViewModel() {

    private val _selectedContactToEdit = MutableStateFlow<Contact?>(null)
    val selectedContactToEdit: StateFlow<Contact?> = _selectedContactToEdit

    val sites = mutableStateListOf<Site>()
    private val _contactWeb = MutableStateFlow<Contact?>(null)
    val contactWeb: StateFlow<Contact?> = _contactWeb

    val isCheckedContactPerson: MutableState<Boolean> = mutableStateOf(false)
    val contactType: MutableState<String> = mutableStateOf("")
    val industry: MutableState<String?> = mutableStateOf(null)
    val contactAddress: MutableState<String> = mutableStateOf("")
    var place: MutableState<ParsedAddress?> = mutableStateOf(null)
    val contactNameNewContact: MutableState<String> = mutableStateOf("")
    val contactZip: MutableState<String> = mutableStateOf("")
    val contactCity: MutableState<String> = mutableStateOf("")
    val contactCountry: MutableState<String> = mutableStateOf("")
    val phoneNewContact: MutableState<String> = mutableStateOf("")
    val emailNewContact: MutableState<String> = mutableStateOf("")
    val contactPersonName: MutableState<String> = mutableStateOf("")
    val contactPersonEmail: MutableState<String> = mutableStateOf("")
    val contactPersonPhone: MutableState<String> = mutableStateOf("")
    val selectedContact: MutableState<String> = mutableStateOf("")

    var places = mutableStateListOf<ParsedAddress>()

    val showPopUpSuccess: MutableState<Boolean> = mutableStateOf(false)
    val showPopUpSuccessDeleted: MutableState<Boolean> = mutableStateOf(false)
    val showPopUpError: MutableState<Boolean> = mutableStateOf(false)
    val showLoader: MutableState<Boolean> = mutableStateOf(false)
    val errorText: MutableState<String> = mutableStateOf("")

    val steps = mutableStateListOf(StepData())
    val showErrorDialog = mutableStateOf(false)

    var contactTypeMap: Map<String, String> = mutableMapOf()

    fun getSites() {
        viewModelScope.launch {
            repository.getSitesFlow().collect {
                sites.clear()
                sites.addAll(it)
            }
        }
    }

    fun clearContactValues() {
        isCheckedContactPerson.value = false
        contactType.value = ""
        industry.value = null
        contactAddress.value = ""
        contactNameNewContact.value = ""
        contactZip.value = ""
        contactCity.value = ""
        contactCountry.value = ""
        phoneNewContact.value = ""
        emailNewContact.value = ""
        contactPersonName.value = ""
        contactPersonEmail.value = ""
        contactPersonPhone.value = ""
        selectedContact.value = ""
        places.clear()
        place.value = null
    }

    fun addContact(onSuccess: () -> Unit, onError: () -> Unit) {

        val errorMessage = when {
            contactNameNewContact.value.isBlank() -> LocalizedStrings.get(
                Res.string.contact_name_required.key,
                currentLanguage.value
            )
//            contactType.value.isBlank() -> "Contact type is required."
//            industry.value.isBlank() -> "Industry is required."
//            contactAddress.value.isBlank() -> "Address is required."
//            place == null -> "Address is not chosen."
//            emailNewContact.value.isEmpty() -> "Email is required."
//            contactCity.value.isBlank() -> "City is required."
//            contactCountry.value.isBlank() -> "Country is required."
//            contactZip.value.isBlank() -> "Zip code is required."
//            phoneNewContact.value.isBlank() -> "Phone is required."
//            contactPersonName.value.isBlank() && isCheckedContactPerson.value -> "Contact person name is required."
//            contactPersonEmail.value.isBlank() && isCheckedContactPerson.value -> "Contact person email is required."
//            contactPersonPhone.value.isBlank() && isCheckedContactPerson.value -> "Contact person phone is required."
            else -> null
        }

        if (errorMessage != null) {
            errorText.value = errorMessage
            onError()
            return
        }

        val contact = Contact(
            name = contactNameNewContact.value,
            contactType = contactTypeMap[contactType.value],
            industry = industry.value,
            addressObject = AddressObject(
                address = contactAddress.value,
                city = contactCity.value,
                country = contactCountry.value,
                zip = contactZip.value,
                lat = place.value?.location?.latitude,
                long = place.value?.location?.longitude
            ),
            email = emailNewContact.value,
            phone = phoneNewContact.value,
            personName = if (isCheckedContactPerson.value) contactPersonName.value else contactNameNewContact.value,
//            personAddress = if (isCheckedContactPerson.value) emailNewContact.value else contactPersonEmail.value,
            personEmail = if (isCheckedContactPerson.value) contactPersonEmail.value else emailNewContact.value,
            personPhone = if (isCheckedContactPerson.value) contactPersonPhone.value else phoneNewContact.value,
            workspaceId = repository.getWorkspaceId()
        )
        viewModelScope.launch {
            when (val result = repository.addContact(contact)) {
                is Resource.Success -> {
                    clearContactValues()
                    onSuccess()
                }

                is Resource.Error -> {
                    errorText.value = result.text ?: stringResourcePlain(Res.string.unknown_error)
                    onError()
                }
            }
        }
    }

    fun updateContact(onSuccess: () -> Unit, onError: () -> Unit) {

        val errorMessage = when {
            contactNameNewContact.value.isBlank() -> LocalizedStrings.get(
                Res.string.contact_name_required.key,
                currentLanguage.value
            )
//            contactType.value.isBlank() -> "Contact type is required."
//            industry.value.isBlank() -> "Industry is required."
//            contactAddress.value.isBlank() -> "Address is required."
//            emailNewContact.value.isEmpty() -> "Email is required."
//            contactCity.value.isBlank() -> "City is required."
//            contactCountry.value.isBlank() -> "Country is required."
//            contactZip.value.isBlank() -> "Zip code is required."
//            phoneNewContact.value.isBlank() -> "Phone is required."
//            contactPersonName.value.isBlank() && !isCheckedContactPerson.value -> "Contact person name is required."
//            contactPersonEmail.value.isBlank() && !isCheckedContactPerson.value -> "Contact person email is required."
//            contactPersonPhone.value.isBlank() && !isCheckedContactPerson.value -> "Contact person phone is required."
            else -> null
        }

        if (errorMessage != null) {
            viewModelScope.launch {
                errorText.value = errorMessage
                onError()
            }
            return
        }

        val contact = Contact(
            name = contactNameNewContact.value,
            contactType = contactTypeMap[contactType.value],
            industry = industry.value,
            addressObject = AddressObject(
                address = contactAddress.value,
                city = contactCity.value,
                country = contactCountry.value,
                zip = contactZip.value,
                lat = place.value?.location?.latitude,
                long = place.value?.location?.longitude
            ),
            email = emailNewContact.value,
            phone = phoneNewContact.value,
            personName = if (isCheckedContactPerson.value) contactPersonName.value else contactNameNewContact.value,
//            personAddress = if (isCheckedContactPerson.value) emailNewContact.value else contactPersonEmail.value,
            personEmail = if (isCheckedContactPerson.value) contactPersonEmail.value else emailNewContact.value,
            personPhone = if (isCheckedContactPerson.value) contactPersonPhone.value else phoneNewContact.value,
            workspaceId = repository.getWorkspaceId()
        )
        viewModelScope.launch {
            if (selectedContactToEdit.value != null) {
                selectedContactToEdit.value?.id?.let { id ->
                    contact.id = id
                    when (val result = repository.updateContact(contact)) {
                        is Resource.Success -> {
                            clearContactValues()
                            onSuccess()
                        }

                        is Resource.Error -> {
                            errorText.value =
                                result.text ?: stringResourcePlain(Res.string.unknown_error)
                            onError()
                        }
                    }
                }
            } else {
                _contactWeb.value?.id?.let { id ->
                    contact.id = id
                    when (val result = repository.updateContact(contact)) {
                        is Resource.Success -> {
                            clearContactValues()
                            onSuccess()
                        }

                        is Resource.Error -> {
                            errorText.value =
                                result.text ?: stringResourcePlain(Res.string.unknown_error)
                            onError()
                        }
                    }
                }
            }
        }
    }

    fun findPlace(name: String) {
        viewModelScope.launch {
            val list = repository.findPlace(name)
            places.clear()
            places.addAll(list?.toList() ?: emptyList())
        }
    }

    fun getContactById(contactId: String) {
        viewModelScope.launch {
            repository.getContactsFlow().collect { contacts ->
                _selectedContactToEdit.value = contacts.firstOrNull { it.id == contactId }
            }
        }
    }

    fun fetchWebContactById(id: String) {
        viewModelScope.launch {
            _contactWeb.value = repository.getContact(id)
        }
    }

    fun deleteContact(
        id: String,
        onSuccess: () -> Unit,
        onError: (String) -> Unit
    ) {
        viewModelScope.launch {
            val result = repository.deleteContactById(id)
            if (result is Resource.Success) {
                clearContactValues()
                onSuccess()
            } else if (result is Resource.Error) {
                errorText.value = result.text ?: stringResourcePlain(Res.string.unknown_error)
                onError(id)
                return@launch
            }
        }
    }

    private fun getCoordinates(): Pair<Double, Double>? {
        val lat = _contactWeb.value?.addressObject?.lat

        val long = _contactWeb.value?.addressObject?.long

        return if (lat != null && long != null) lat to long else null
    }

    fun getContactMarkers(): List<Marker> {
        return getCoordinates()?.let { (lat, long) ->
            listOf(Marker(lat = lat, lng = long, title = ""))
        } ?: emptyList()
    }
}